var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassedIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 33.75,
    fill: "#BDE541"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7451 49.4579L58.6606 30L63.75 35.4657L39.7451 60L26.25 46.1905L31.3259 40.9194L39.7451 49.4579Z",
    fill: "#193051"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassedIconBlue);
export default __webpack_public_path__ + "static/media/passed-icon-blue.830fb4b2518a6a44e97a8f60609c77af.svg";
export { ForwardRef as ReactComponent };